import { createFileRoute } from '@tanstack/react-router'
import { NoFinanceAccess } from '~/features/compensation/parts'
import { loaderSeason, rulesQuery, typesQuery } from '~/features/compensation/queries'
import { TypesPage } from '~/features/compensation/TypesPage'
import { useCan } from '~/lib/session'

export const Route = createFileRoute('/_app/verein/praemien/arten')({
  loader: async ({ context }) => {
    const s = await loaderSeason(context.queryClient)
    if (s?.canRead) await Promise.all([context.queryClient.ensureQueryData(typesQuery()), context.queryClient.ensureQueryData(rulesQuery())])
  },
  component: function Arten() {
    return useCan()('finance.read') ? <TypesPage /> : <NoFinanceAccess title="Vergütungsarten" />
  },
})
